// extracted by mini-css-extract-plugin
export default {"new-layer-body":"HeaderButton__new-layer-body___3xe16","toc-header-button":"HeaderButton__toc-header-button___1UgKW","plus-icon":"HeaderButton__plus-icon___2KryD"};